import Request from './request';

async function fetch(data) {// 获取列表
    return Request('get', "api/economies/", data);
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/economies/" + id, data);
}

async function complete(id, data) {
    return Request("post", "api/economies/complete/" + id, data)
}

async function cancel(id) {
    return Request("post", "api/economies/cancel/" + id)
}

export default {
    fetch,
    fetchOne,
    complete,
    cancel,
};